import { render, staticRenderFns } from "./pi-search.vue?vue&type=template&id=2b589841&scoped=true&"
import script from "./pi-search.vue?vue&type=script&lang=ts&"
export * from "./pi-search.vue?vue&type=script&lang=ts&"
import style0 from "./pi-search.vue?vue&type=style&index=0&id=2b589841&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b589841",
  null
  
)

export default component.exports